/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionMobilityStatusEnum } from './subscriptionMobilityStatusEnum';


export interface SubscriptionMobilityAudit { 
    id: number;
    serial_number: string;
    source_org_id: string;
    destination_org_id: string;
    status: SubscriptionMobilityStatusEnum;
    info?: string;
    requested_by: string;
    created_ts: Date;
    updated_ts: Date;
}
export namespace SubscriptionMobilityAudit {
}


